import { render, staticRenderFns } from "./UserProductSign.vue?vue&type=template&id=9c3d2fa2&"
import script from "./UserProductSign.vue?vue&type=script&lang=js&"
export * from "./UserProductSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports